import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ParkCard from "@/components/ParkCard";
import CompareDrawer from "@/components/CompareDrawer";
import { api } from "@/lib/api";
import { ParkCardSkeletonGrid } from "@/components/Skeletons";

export default function RegionGuide() {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.regionGuide(slug).then(setData).catch(() => setData("notfound"));
  }, [slug]);

  if (data === "notfound") return (
    <div className="App"><Nav /><div className="max-w-3xl mx-auto py-32 text-center"><h2 className="font-display text-2xl">Region not found</h2><Link to="/regions" className="btn-primary mt-6">All regions</Link></div></div>
  );

  return (
    <div className="App">
      <Nav />
      <header className="bg-forest text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <span className="label-eyebrow text-white/70">Region guide</span>
          <h1 className="font-display font-extrabold text-5xl mt-2" data-testid="region-title">
            Best caravan parks in {data?.region || "..."}
          </h1>
          {data && (
            <p className="mt-4 text-white/85 max-w-3xl leading-relaxed">{data.description}</p>
          )}
          {data && <p className="mt-3 text-white/60 text-sm">{data.park_count} parks listed</p>}
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {!data ? <ParkCardSkeletonGrid count={6} /> : (
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
            {data.parks.map((p) => <ParkCard key={p.slug} park={p} />)}
          </div>
        )}
      </div>
      <CompareDrawer />
      <Footer />
    </div>
  );
}
